/* eslint-disable import/prefer-default-export */
export const getAuth = {
  "Access-Control-Allow-Origin": "*",
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const registerAuth = {
  Accept: "application/json",
  "Content-Type": "multipart/form-data",
};
